// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Added Comment Lines'
// Modified Date : 22-09-2025

import CashTransactionTypes from './common-transaction.types';

/** ***************** GET COMPANY FINANCE ACCOUNT TYPE LIST START *********************** */
export const getCompanyFinanceAccountTypeListStart = (getData: any) => ({
	type: CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_START,
	payload: getData,
});

export const getCompanyFinanceAccountTypeListSuccess = (successData: any) => ({
	type: CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_SUCCESS,
	payload: successData,
});

export const getCompanyFinanceAccountTypeListFailure = (failureData: any) => ({
	type: CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_FAILURE,
	payload: failureData,
});

export const getCompanyFinanceAccountTypeListResponseReset = () => ({
	type: CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_RESPONSE_RESET,
});

export const getCompanyFinanceAccountTypeListResponseChanged = () => ({
	type: CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_RESPONSE_CHANGED,
});
/** ***************** GET COMPANY FINANCE ACCOUNT TYPE LIST END *********************** */

/******************** GET ACCOUNT DAY LIST START ************************* */
export const getAccountDayBookListStart = (getData: any) => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_START,
	payload: getData,
});

export const getAccountDayBookListSuccess = (successData: any) => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_SUCCESS,
	payload: successData,
});

export const getAccountDayBookListFailure = (failureData: any) => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_FAILURE,
	payload: failureData,
});

export const getAccountDayBookListResponseReset = () => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_RESPONSE_RESET,
});

export const getAccountDayBookListResponseChanged = () => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_RESPONSE_CHANGED,
});
/*************** GET ACCOUNT DAY LIST END ***************** */

/** ***************** ADD CASH TRANSACTION DETAILS START *********************** */
export const addCashTransactionDetailsStart = (addData: any) => ({
	type: CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_START,
	payload: addData,
});

export const addCashTransactionDetailsSuccess = (successData: any) => ({
	type: CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});

export const addCashTransactionDetailsFailure = (failureData: any) => ({
	type: CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});

export const addCashTransactionDetailsResponseReset = () => ({
	type: CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_RESPONSE_RESET,
});

export const addCashTransactionDetailsResponseChanged = () => ({
	type: CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD CASH TRANSACTION DETAILS END *********************** */

/** ***************** UPDATE CASH TRANSACTION DETAILS START *********************** */
export const updateCashTransactionDetailsStart = (updateData: any) => ({
	type: CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_START,
	payload: updateData,
});

export const updateCashTransactionDetailsSuccess = (successData: any) => ({
	type: CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});
export const updateCashTransactionDetailsFailure = (failureData: any) => ({
	type: CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});
export const updateCashTransactionDetailsResponseReset = () => ({
	type: CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_RESPONSE_RESET,
});
export const updateCashTransactionDetailsResponseChanged = () => ({
	type: CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE CASH TRANSACTION DETAILS END *********************** */

// /** ***************** GET CASH TRANSACTION LIST START *********************** */
export const getCashTransactionListStart = (getData: any) => ({
	type: CashTransactionTypes.GET_CASH_TRANSACTION_LIST_START,
	payload: getData,
});
export const getCashTransactionListSuccess = (successData: any) => ({
	type: CashTransactionTypes.GET_CASH_TRANSACTION_LIST_SUCCESS,
	payload: successData,
});
export const getCashTransactionListFailure = (failureData: any) => ({
	type: CashTransactionTypes.GET_CASH_TRANSACTION_LIST_FAILURE,
	payload: failureData,
});
export const getCashTransactionListResponseReset = () => ({
	type: CashTransactionTypes.GET_CASH_TRANSACTION_LIST_RESPONSE_RESET,
});
export const getCashTransactionListResponseChanged = () => ({
	type: CashTransactionTypes.GET_CASH_TRANSACTION_LIST_RESPONSE_CHANGED,
});
// /** ***************** GET CASH TRANSACTION LIST END *********************** */

/** ***************** FETCH CASH TRANSACTION DETAILS START *********************** */
export const fetchCashTransactionDetailsStart = (fetchData: any) => ({
	type: CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_START,
	payload: fetchData,
});
export const fetchCashTransactionDetailsSuccess = (successData: any) => ({
	type: CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});
export const fetchCashTransactionDetailsFailure = (failureData: any) => ({
	type: CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});
export const fetchCashTransactionDetailsResponseReset = () => ({
	type: CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_RESPONSE_RESET,
});
export const fetchCashTransactionDetailsResponseChanged = () => ({
	type: CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH  CASH TRANSACTION DETAILS END *********************** */

/** ***************** DELETE CASH TRANSACTION DETAILS START *********************** */
export const deleteCashTransactionDetailsStart = (deleteData: any) => ({
	type: CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_START,
	payload: deleteData,
});
export const deleteCashTransactionDetailsSuccess = (successData: any) => ({
	type: CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_SUCCESS,
	payload: successData,
});
export const deleteCashTransactionDetailsFailure = (failureData: any) => ({
	type: CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_FAILURE,
	payload: failureData,
});
export const deleteCashTransactionDetailsResponseReset = () => ({
	type: CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_RESPONSE_RESET,
});
export const deleteCashTransactionDetailsResponseChanged = () => ({
	type: CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE CASH TRANSACTION DETAILS END *********************** */

/** ***************** GET PARTICULAR CASH TRANSACTION LIST START *********************** */
export const getParticularCashTransactionListStart = (getData: any) => ({
	type: CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_START,
	payload: getData,
});

export const getParticularCashTransactionListSuccess = (successData: any) => ({
	type: CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_SUCCESS,
	payload: successData,
});

export const getParticularCashTransactionListFailure = (failureData: any) => ({
	type: CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_FAILURE,
	payload: failureData,
});
export const getParticularCashTransactionListResponseReset = () => ({
	type: CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_RESPONSE_RESET,
});
export const getParticularCashTransactionListResponseChanged = () => ({
	type: CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PARTICULAR CASH TRANSACTION LIST END *********************** */

/** ***************** GET VOUCHER COUNT BASED ON COMPANY START *********************** */
export const getVoucherCountBasedOnCompanyStart = (payload: any) => ({
	type: CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_START,
	payload,
});

export const getVoucherCountBasedOnCompanySuccess = (payload: any) => ({
	type: CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_SUCCESS,
	payload,
});

export const getVoucherCountBasedOnCompanyFailure = (payload: any) => ({
	type: CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_FAILURE,
	payload,
});

export const getVoucherCountBasedOnCompanyResponseReset = () => ({
	type: CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_RESET,
});

export const getVoucherCountBasedOnCompanyResponseChanged = () => ({
	type: CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_CHANGED,
});
/** ***************** GET VOUCHER COUNT BASED ON COMPANY END *********************** */

/** ***************** CHECK BRANCH EOD DONE START *********************** */
export const checkBranchEODDoneStart = (payload: any) => ({
	type: CashTransactionTypes.CHECK_BRANCH_EOD_DONE_START,
	payload,
});

export const checkBranchEODDoneSuccess = (payload: any) => ({
	type: CashTransactionTypes.CHECK_BRANCH_EOD_DONE_SUCCESS,
	payload,
});

export const checkBranchEODDoneFailure = (payload: any) => ({
	type: CashTransactionTypes.CHECK_BRANCH_EOD_DONE_FAILURE,
	payload,
});

export const checkBranchEODDoneResponseReset = () => ({
	type: CashTransactionTypes.CHECK_BRANCH_EOD_DONE_RESPONSE_RESET,
});

export const checkBranchEODDoneResponseChanged = () => ({
	type: CashTransactionTypes.CHECK_BRANCH_EOD_DONE_RESPONSE_CHANGED,
});
/** ***************** CHECK BRANCH EOD DONE END *********************** */

// /*** UPDATE SELECTED TRANSACTION IS_APPROVE START ***/
export const updateSelectedTransactionIsApproveStart = (updateData: any) => ({
	type: CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_START,
	payload: updateData,
});

export const updateSelectedTransactionIsApproveSuccess = (successData: any) => ({
	type: CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_SUCCESS,
	payload: successData,
});

export const updateSelectedTransactionIsApproveFailure = (failureData: any) => ({
	type: CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_FAILURE,
	payload: failureData,
});

export const updateSelectedTransactionIsApproveResponseReset = () => ({
	type: CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_RESPONSE_RESET,
});

export const updateSelectedTransactionIsApproveResponseChanged = () => ({
	type: CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_RESPONSE_CHANGED,
});
/*********** UPDATE SELECTED TRANSACTION IS_APPROVE END *******************/

/** ***************** GET VALUES MODAL START *********************** */
export const getValuesModalStart = (payload: any) => ({
	type: CashTransactionTypes.GET_VALUES_MODAL_START,
	payload,
});

export const getValuesModalSuccess = (payload: any) => ({
	type: CashTransactionTypes.GET_VALUES_MODAL_SUCCESS,
	payload,
});

export const getValuesModalFailure = (payload: any) => ({
	type: CashTransactionTypes.GET_VALUES_MODAL_FAILURE,
	payload,
});

export const getValuesModalResponseReset = () => ({
	type: CashTransactionTypes.GET_VALUES_MODAL_RESPONSE_RESET,
});

export const getValuesModalResponseChanged = (payload?: any) => ({
	type: CashTransactionTypes.GET_VALUES_MODAL_RESPONSE_CHANGED,
	payload,
});
/** ***************** GET VALUES MODAL END *********************** */

/** ***************** GET ACCOUNT DAY BOOK FOR ACCOUNT START *********************** */
export const getAccountDayBookForAccountStart = (getData: any) => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_START,
	payload: getData,
});

export const getAccountDayBookForAccountSuccess = (successData: any) => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_SUCCESS,
	payload: successData,
});

export const getAccountDayBookForAccountFailure = (failureData: any) => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_FAILURE,
	payload: failureData,
});

export const getAccountDayBookForAccountResponseReset = () => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_RESPONSE_RESET,
});

export const getAccountDayBookForAccountResponseChanged = () => ({
	type: CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_RESPONSE_CHANGED,
});
/** ***************** GET ACCOUNT DAY BOOK FOR ACCOUNT END *********************** */
